import { SyntheseInventaireEdition } from './synthese-inventaire-edition';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';
import { MapStringNumberConverter } from 'src/app/core/services/mapper/converters';

export class SyntheseInventaireGroupeeEdition {
    static jsonMap = {
        surfaceEspece: { key: 'surfaceEspece', converter: new MapStringNumberConverter(), optional: true },
        surfaceTotale: { key: 'surfaceTotale', optional: true },
        surfaceIrriguee: { key: 'surfaceIrriguee', optional: true },
        surfaceGrele: { key: 'surfaceGrele', optional: true },
        surfaceGel: { key: 'surfaceGel', optional: true },
        surfaceBio: { key: 'surfaceBio', optional: true },
        syntheseInventaireEditionList: {
            key: 'syntheseInventaireEditionList',
            converter: new (ArrayClassConverterFactory.build(SyntheseInventaireEdition))(),
            optional: true,
            default: () => []
        }
    };

    surfaceEspece: Map<string, number>;
    surfaceTotale: number;
    surfaceIrriguee: number;
    surfaceGrele: number;
    surfaceGel: number;
    surfaceBio: number;
    syntheseInventaireEditionList: SyntheseInventaireEdition[];
}
